/**
 * Контракт шага мастера онбординга.
 *
 * Шаг — «глупый» компонент: показывает ранее сохранённый ответ (`value`) и сообщает черновик
 * наверх (`onChange`). Сохранение в `PATCH /api/onboarding/step/{n}` делает `OnboardingPage`
 * по кнопке «Далее». Исключение — шаги с собственными эффектами (согласия, погода, фото,
 * Telegram): они пишут в свои эндпоинты сразу, а в ответ шага кладут краткий результат,
 * чтобы возобновление мастера показывало, что уже сделано.
 */
export interface StepProps {
    /** Ранее сохранённый ответ этого шага (из `stepAnswers`), если он есть. */
    value: unknown;
    /** Обновление черновика ответа шага. */
    onChange: (answer: unknown) => void;
    /** Все ответы мастера — нужны финальному шагу для итогов. */
    answers: Record<string, unknown>;
}

/** Ответ шага как объект: ответы старых версий мастера могли быть строкой или списком. */
export const asRecord = (value: unknown): Record<string, unknown> =>
    (value && typeof value === 'object' && !Array.isArray(value))
        ? value as Record<string, unknown>
        : {};

/** Строковое поле ответа шага. */
export const stringField = (value: unknown, field: string): string => {
    const raw = asRecord(value)[field];
    return typeof raw === 'string' || typeof raw === 'number' ? String(raw) : '';
};

/** Список строк из поля ответа шага (коды выбранных вариантов). */
export const listField = (value: unknown, field: string): string[] => {
    const raw = asRecord(value)[field];
    return Array.isArray(raw) ? raw.filter((v): v is string => typeof v === 'string') : [];
};
